/**
 * Step 2: Create up to 2 tunnels only if required by airflow/layout
 */
import { IBotData, IAHUParams, ITunnel } from '../../../../models';
import { dispatchMutation, dispatchQuery } from '../../../../utils/dispatch.utils';
import { ahuApi } from '../../../../services';
import { bot_tunnel_configuration_ids } from '../../../data/bot';

export async function step2CreateTunnels(
  ahuId: number,
  botData: IBotData,
  ahuParams: IAHUParams,
  getOptions: () => { signal?: AbortSignal },
): Promise<{ tunnels: any[]; tunnelIds: number[] }> {
  const tunnelIds: number[] = [];

  // Get initial tunnels (AHU creation creates first tunnel)
  let tunnelsResult: any = await dispatchQuery(
    ahuApi.endpoints.getAhuTunnels,
    ahuId,
    getOptions(),
  );
  if (!tunnelsResult || tunnelsResult.length === 0) {
    throw new Error('Failed to get tunnels for created AHU');
  }

  const tunnels: any[] = [tunnelsResult[0]];
  tunnelIds.push(tunnelsResult[0].id);

  // Check if dual tunnel configuration is required
  const tunnel_configuration_id =
    bot_tunnel_configuration_ids[
      botData.tunnel_configuration as keyof typeof bot_tunnel_configuration_ids
    ];
  const isDualTunnel = tunnel_configuration_id !== 1;
  const needsSecondTunnel = isDualTunnel && botData.tunnels.length === 2;

  if (needsSecondTunnel && tunnelsResult.length === 1) {
    // Get the index_id for the second tunnel from ahuParams
    const tunnelIndexes = ahuParams.tunnels?.indexes || [];
    // Find the second tunnel index_id
    let secondTunnelIndexId = tunnelIndexes.find(
      (e) => e.id === tunnel_configuration_id,
    )?.id;

    // Get airflow_direction_id from per_tunnel[1] if available
    const airflowDirectionId = botData.tunnels[1].airflow_direction_id ?? 1;

    // Create the second tunnel
    const new_tunnel: ITunnel = await dispatchMutation(
      ahuApi.endpoints.createAhuTunnel,
      {
        body: {
          name: 'tunnel',
          ahu_id: ahuId,
          index_id: secondTunnelIndexId,
          airflow_direction_id: airflowDirectionId,
        },
      },
      getOptions(),
    );
    // Add second tunnel to arrays
    tunnels.push(new_tunnel);
    tunnelIds.push(new_tunnel.id);
  }

  return { tunnels, tunnelIds };
}
